import type { ApiServiceConfig } from "~/services/ApiBaseService";
import { ApiBaseService } from "~/services/ApiBaseService";

export class CarerixPartnerApi extends ApiBaseService {
    public tenant: string;
    public userId: string;

    constructor(config: ApiServiceConfig, tenant: string, userId: string) {
        super(config);

        this.tenant = tenant;
        this.userId = userId;
    }

    public me() {
        return this.request(this.route("api.third-party.carerix.me", "third-party/carerix/me"), {
            query: this.query(),
            headers: {
                'X-Referer': useRequestURL().href
            },
        });
    }

    private query(query: Record<string, any> = {}) {
        return {
            ...query,
            tenant: this.tenant,
            userId: this.userId
        };
    }
}